export const GET_DETAIL_CUSTOMER = "GET_DETAIL_CUSTOMER"
export const GET_DETAIL_CUSTOMER_ERR = "GET_DETAIL_CUSTOMER_ERR"

export const CLEAR_CUSTOMER_DETAILS = "CLEAR_CUSTOMER_DETAILS"